<template>
  <v-main>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <h1 class="mb-4">{{ ct.TitleText }}</h1>
          <v-progress-linear v-if="loading" :indeterminate="true" ></v-progress-linear>
          <v-card v-else raised>
            <v-card-text>
              <v-form ref="form" v-model="valid">
                <v-select v-if="!isHide('Facility')" :readonly="readonlyFacility" :items="form.facilitiesDisplay" v-model="form.facilityDisplay" @change="facilityChanged" :label="$t('Facility')" :rules="(isRequired('Facility') ? [rules.required] : [])"></v-select>

                <v-autocomplete
                  v-if="!isHide('Vehicle')" :readonly="isReadonly('Vehicle')" :items="form.vehicles" v-model="form.vehicleNo" @change="vehicleChanged" v-on:keyup="searchVehicle = $event.target.value" @keyup="searchDelayed" :label="$t('Vehicle')" :rules="isRequired('Vehicle') ? [rules.required] : []"  @focus="focusVehicle" :no-data-text="ct.NoDataAvailable">
                  <template v-slot:append><v-btn v-if="!disableCreateVehicle" @click="newVehicleNo = (form.vehicles.length === 0 ? searchVehicle : ''); newVehicleDialog = true" color="primary" icon class="mb-n1 mr-n1"><v-icon>add</v-icon></v-btn></template>
                </v-autocomplete>
                <v-progress-linear v-if="searching" :indeterminate="true" class="mt-n6"></v-progress-linear>

                <v-autocomplete v-if="!isHide('Agreement')" :readonly="isReadonly('Agreement')" :items="form.agreements" v-model="form.agreementNo" :label="$t('Agreement')" @change="agreementChanged" v-on:keyup="searchAgreement = $event.target.value" @keyup="searchDelayedAgreement" :rules="(isRequired('Agreement') ? [rules.required] : [])"></v-autocomplete>
                <v-progress-linear v-if="searchingAgreement" :indeterminate="true" class="mt-n6"></v-progress-linear>

                <v-autocomplete v-if="!isHide('Delivery')" :readonly="isReadonly('Delivery')" :items="form.deliveries" v-model="form.deliveryNo" :label="$t('Delivery')" @change="deliveryChanged" :disabled="!form.agreementNo" :rules="(isRequired('Delivery') ? [rules.required] : [])" :no-data-text="ct.NoDataAvailable"></v-autocomplete>

                <v-autocomplete v-if="!isHide('Customer')" :readonly="isReadonly('Customer')" :items="form.customers" v-model="form.customerNo" v-on:keyup="searchCustomer = $event.target.value" @keyup="searchDelayedCustomer" :label="$t('Customer')" :rules="(isRequired('Customer') ? [rules.required] : [])"></v-autocomplete>
                <v-progress-linear v-if="searchingCustomer" :indeterminate="true" class="mt-n6"></v-progress-linear>

                <v-autocomplete v-if="!isHide('Article')" :readonly="isReadonly('Article')" :items="form.articles" v-model="form.articleNo" @change="articleChanged" :label="$t('Article')" :rules="(isRequired('Article') ? [rules.required] : [])"></v-autocomplete>
                <v-autocomplete v-if="!isHide('Carrier')" :readonly="isReadonly('Carrier')" :items="form.carriers" v-model="form.carrierNo" :label="$t('Carrier')" :rules="(isRequired('Carrier') ? [rules.required] : [])"></v-autocomplete>
                <v-text-field v-if="!isHide('RequisitionNo1')" :readonly="isReadonly('RequisitionNo1')" v-model="form.requisitionNo1" :label="$t('RequisitionNo1')" :rules="(isRequired('RequisitionNo1') ? [rules.required] : [])"></v-text-field>
                <v-text-field v-if="!isHide('RequisitionNo2')" :readonly="isReadonly('RequisitionNo2')" v-model="form.requisitionNo2" :label="$t('RequisitionNo2')" :rules="(isRequired('RequisitionNo2') ? [rules.required] : [])"></v-text-field>
                <v-autocomplete v-if="!isHide('Plant')" :readonly="isReadonly('Plant')" :items="form.plants" v-model="form.plantNo" :label="$t('Plant')" :rules="(isRequired('Plant') ? [rules.required] : [])"></v-autocomplete>
                <v-text-field v-if="!isHide('Comment')" :readonly="isReadonly('Comment')" v-model="form.comment1" :label="$t('Comment')" :maxlength="100" :rules="(isRequired('Comment') ? [rules.required] : [])"></v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn :loading="saving" min-width="97px" :disabled="!valid" @click="save" color="success">{{ct.SaveBtnText}} {{buttonAppend}}</v-btn>
              <v-btn color="primary" @click="preventLeave = false; $router.go(-1)">{{$t("Cancel")}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>

       <!-- NEW VEHICLE DIALOG -->
        <v-dialog v-model="newVehicleDialog" max-width="300" persistent>
          <v-card >
            <v-card-title class="headline">{{$t('Create') + ' ' + $t('New').toLowerCase() + ' ' + $t('Vehicle')}}</v-card-title>
            <v-divider class="mb-n4"></v-divider>
            <v-card-actions>
              <v-card-text>
                <v-text-field class="mb-4" v-model="newVehicleNo" autofocus hide-details="true" :label="$t('No.')" :rules="[rules.required]"></v-text-field>
                <v-text-field class="mb-4" v-model="newVehicleName" hide-details="true" :label="ct.Name"></v-text-field>
                <v-text-field class="mb-4 licensplate-input" :value="newVehicleLicensePlateNo" v-model="newVehicleLicensePlateNo" hide-details="true" :label="$t('VehicleLicensePlateNo')" :rules="[rules.required]" @keydown.space.prevent></v-text-field>
                <v-btn class="ml-8 mt-6" color="success" @click="newVehicleDialog = false; saveVehicle()">{{$t("Save")}}</v-btn>
                <v-btn class="ml-6 mt-6" color="primary" @click="newVehicleDialog = false">{{$t("Cancel")}}</v-btn>
            </v-card-text>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-layout>
    </v-container>
  </v-main>
</template>

<script>
import { app } from '@/main'
import * as Archive from '@/core/archive'
import * as WheelLoader from '@/modules/wheel-loader/wheel-loader'
import ct from '@/core/mixins/common-translations'
import rules from '@/core/mixins/common-rules'
import preventLeave from '@/core/mixins/preventLeave'
import * as LocalStorage from '@/core/local-storage'
import * as Security from '@/core/security'
import { validSearchKeyUp } from '@/core/utils'
import _ from 'lodash' // clone

export default {
  mixins: [ct, rules, preventLeave],
  data: () => ({
    dataType: 'wheel-loader-registration',
    loading: true,
    saving: false,
    valid: true,
    readonlyFacility: true, // Prevent errors: true when editing registration, false when creating new registration
    hiddenFields: [],
    readonlyFields: [],
    requiredFields: [],
    redirectTo: 'wheel-loader-registrations',
    searchVehicle: '',
    searching: false,
    searchCustomer: '',
    searchingCustomer: false,
    searchAgreement: '',
    searchingAgreement: false,
    searchTimer: null,
    newVehicleDialog: false,
    newVehicleNo: null,
    newVehicleName: null,
    newVehicleLicensePlateNo: null,
    useFacilityDescription: false,
    disableCreateVehicle: false,
    form: {
      facilities: [],
      articles: [],
      agreements: [],
      deliveries: [],
      customers: [],
      vehicles: [],
      plants: [],
      carriers: [],
      facilityNo: '',
      facilitiesDescription: [],
      facilityDescription: '',
      facilityDisplay: '',
      facilitiesDisplay: [],
      articleNo: '',
      agreementNo: '',
      deliveryNo: '',
      carrierNo: '',
      customerNo: '',
      vehicleNo: '',
      vehicleLicensePlateNo: '',
      requisitionNo1: '',
      requisitionNo2: '',
      comment1: '',
      plantNo: '',
      searchCriteria: '',
      top: 100
    },
    id: undefined, // for Create/Edit support in TitleText
    wlReg: {
      id: '00000000-0000-0000-0000-000000000000',
      registrationId: '00000000-0000-0000-0000-000000000000',
      facilityNo: null,
      finishedDate: null,
      finishedBy: null,
      comment: null,
      reg: null
    }
  }),
  computed: {
  },
  methods: {
    searchDelayed (val) {
      // Only Backspace and normal keys starts a search
      if (validSearchKeyUp(val.keyCode)) {
        if (this.searchTimer) clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(this.searchVehicles, 300)
      }
    },
    searchDelayedCustomer (val) {
      // Only normal/Backspace/Delete keys must start a search
      if (validSearchKeyUp(val.keyCode)) {
        if (this.searchTimer) clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(this.searchCustomers, 600)
      }
    },
    searchDelayedAgreement (val) {
      // Only normal/Backspace/Delete keys must start a search
      if (validSearchKeyUp(val.keyCode)) {
        if (this.searchTimer) clearTimeout(this.searchTimer)
        this.searchTimer = setTimeout(this.searchAgreements, 600)
      }
    },
    searchVehicles () {
      if (this.searchVehicle.length < 1) this.form.vehicles = []
      // Temporary show Search vehicle xxx ....
      this.form.vehicles = [this.searchVehicle.length ? this.$t('Searching') + ' ' + this.searchVehicle + ' ...' : this.$t('Search')]
      // Only update if not already searching and serarch text is entered
      if (!this.searching && this.searchVehicle) this.updateVehicles(this.searchVehicle)
    },
    searchCustomers () {
      if (this.searchCustomer.length < 1) this.form.customers = []
      // Temporary show Search customer xxx ....
      this.form.customers = [this.searchCustomer.length ? this.$t('Searching') + ' ' + this.searchCustomer + ' ...' : this.$t('Search')]
      // Only update if not already searching and serarch text is entered
      if (!this.searching && this.searchCustomer) this.updateCustomers(this.searchCustomer)
    },
    searchAgreements () {
      if (this.searchAgreement.length < 1) this.form.agreements = []
      // Temporary show Search agreement xxx ....
      this.form.agreements = [this.searchAgreement.length ? this.$t('Searching') + ' ' + this.searchAgreement + ' ...' : this.$t('Search')]
      // Only update if not already searching and serarch text is entered
      if (!this.searching && this.searchAgreement) this.updateAgreements(this.searchAgreement)
    },
    focusVehicle () {
      // Temporary show Search
      if (this.form.vehicles.length !== 1) this.form.vehicles = [this.$t('Search')]
    },
    async updateVehicles (search) {
      this.searching = true

      // "search" for one vehicle (single lookup)
      if (search.length === 1) {
        const res = await Archive.loadVehicle({ facilityNo: this.form.facilityNo, vehicleNo: search })
        if (!res.failed) {
          if (res.data) {
            const item = res.data
            if (item) {
              this.form.vehicles = [{
                text: [item.No, item.LicensePlateNo].filter(Boolean).join(' - '),
                value: item.No,
                obj: item
              }]
            }
          } else {
            this.form.vehicles = []
          }
        }
      } else { // search for many vehicles (via searchText)
        const res = await WheelLoader.loadVehicles({ facility: this.form.facilityNo, searchText: search })
        if (!res.failed) {
          this.form.vehicles = res.data.map(item => {
            return {
              text: [item.No, item.LicensePlateNo].filter(Boolean).join(' - '),
              value: item.No,
              obj: item
            }
          })
        }
      }

      this.searching = false
    },
    async updateCustomers (search) {
      this.searchingCustomer = true
      const res = await Archive.loadCustomers({ facilityNo: this.form.facilityNo, searchCriteria: search, top: this.form.top })
      if (!res.failed) {
        this.form.customers = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      this.searchingCustomer = false
    },
    async updateAgreements (search) {
      this.searchingAgreement = true
      const res = await Archive.loadAgreements({ facilityNo: this.form.facilityNo, searchCriteria: search, top: this.form.top, agreementNoFilter: this.agreementNoFilter, DataCode: 'quick' })
      if (!res.failed) {
        this.form.agreements = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      this.searchingAgreement = false
    },
    async loadVehicle (search) {
      const res = await Archive.loadVehicle({ facilityNo: this.form.facilityNo, vehicleNo: search })
      if (!res.failed) {
        if (res.data) {
          const item = res.data
          if (item) {
            this.form.vehicles = [{
              text: [item.No, item.LicensePlateNo].filter(Boolean).join(' - '),
              value: item.No,
              obj: item
            }]
          }
          // on edit: filtered articles and agreements are loaded (Valid Choice)
          this.articleNoFilter = this.getData1FromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ValidArticles')
          this.agreementNoFilter = this.getData1FromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ValidAgreements')
          this.loadFilteredArticles()
          this.loadAgreement(this.form.agreementNo)
        }
      }
    },
    async saveVehicle () {
      // Check newVehicleNo does not already exist
      let foundNo = false
      var res = await Archive.loadVehicle({ facilityNo: this.form.facilityNo, vehicleNo: this.newVehicleNo })
      if (!res.failed && res.data && res.data.No === this.newVehicleNo) { foundNo = true }

      // Check newVehicleLicensePlateNo does not already exist
      let foundLicensePlate = false
      if (!foundNo) {
        this.newVehicleLicensePlateNo = this.newVehicleLicensePlateNo.toUpperCase()
        res = await WheelLoader.loadVehicles({ facility: this.form.facilityNo, searchText: this.newVehicleLicensePlateNo })
        if (!res.failed && res.data && res.data.find(v => v.LicensePlateNo.toUpperCase() === this.newVehicleLicensePlateNo) != null) { foundLicensePlate = true }
      }

      // Save new vehicle
      if (!foundNo && !foundLicensePlate) {
        const vehicle = {
          Id: '00000000-0000-0000-0000-000000000000',
          Facility: this.form.facilityNo,
          No: this.newVehicleNo,
          Name: this.newVehicleName,
          LicensePlateNo: this.newVehicleLicensePlateNo,
          Details: []
        }
        res = await Archive.saveVehicle(vehicle)
        if (!res.failed) {
          // Refresh Vehicle field
          this.searchVehicle = this.newVehicleNo
          this.updateVehicles(this.searchVehicle)
          this.form.vehicleNo = this.newVehicleNo
          this.$root.$message.showSuccess(this.$t('Vehicle') + ' ' + this.newVehicleNo + ' ' + this.$t('Saved').toLowerCase())
        }
      } else { this.$root.$message.showError(this.$t('Vehicle') + ' ' + (foundNo ? this.newVehicleNo : '') + (foundLicensePlate ? this.newVehicleLicensePlateNo : '') + ' ' + this.$t('already exists')) }

      // clean dialog
      this.newVehicleNo = ''
      this.newVehicleName = ''
      this.newVehicleLicensePlateNo = ''
    },
    // this.articleNoFilter comes from the selected Vehicles or Agreement DetailValidArticles when Valid Choice is installed and some few Articles are selected on the Vehicle/Agreement,
    // else null that will return all (non-deleted) Articles
    async loadFilteredArticles () {
      const res = await WheelLoader.loadFilteredArticles({ facilityNo: this.form.facilityNo, ArticleNoFilter: this.articleNoFilter })
      if (!res.failed) {
        this.form.articles = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }
    },
    async loadAgreement (number) {
      const res = await Archive.loadAgreement({ facilityNo: this.form.facilityNo, no: number, searchCriteria: null, top: this.form.top, agreementNoFilter: this.agreementNoFilter, DataCode: 'quick' })
      if (!res.failed) {
        this.form.agreements = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }
    },
    async updateUi () {
      this.form.facilities = [this.$t('Loading ...')]
      this.form.facilitiesDescription = [this.$t('Loading ...')]
      this.form.agreements = [this.$t('Loading ...')]
      this.form.deliveries = [this.$t('Loading ...')]
      this.form.customers = [this.$t('Loading ...')]
      this.form.articles = [this.$t('Loading ...')]
      this.form.carriers = [this.$t('Loading ...')]
      this.form.plants = [this.$t('Loading ...')]

      let res = await Archive.loadFacilities(true)
      const facilitiesResDescription = _.cloneDeep(res)
      if (!res.failed) {
        const noGlobal = res.data.filter(o => o.No !== '')
        this.form.facilities = noGlobal.map(item => {
          return {
            text: item.No,
            value: item.No,
            obj: item
          }
        })
        this.form.facilitiesDisplay = this.form.facilities
        if (this.useFacilityDescription) {
          var d = facilitiesResDescription.data
          if (!d.includes('')) d.unshift({ No: '', Description: '' })
          const noGlobal2 = d.filter(o => o.No !== '')
          this.form.facilitiesDescription = noGlobal2.map(item => {
            return {
              text: item.Description,
              value: item.Description,
              item: item
            }
          })
          this.form.facilitiesDisplay = this.form.facilitiesDescription
        }
      }

      if (this.useFacilityDescription) {
        if (this.form.facilityNo === null || this.form.facilityNo === 'null') {
          this.form.facilityDisplay = ''
        } else {
          this.form.facilityDisplay = this.form.facilitiesDescription.find(f => f.item.No === this.form.facilityNo).value
        }
      } else {
        if (this.form.facilityNo == null || this.form.facilityNo === 'null') {
          this.form.facilityDisplay = ''
        } else {
          this.form.facilityDisplay = this.form.facilities.find(f => f.obj.No === this.form.facilityNo).value
        }
      }

      res = await Archive.loadCarriers(this.form.facilityNo)
      if (!res.failed) {
        this.form.carriers = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      res = await Archive.loadPlants(this.form.facilityNo)
      if (!res.failed) {
        this.form.plants = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      this.reloadCustomers()

      // Load Filtered Articles via Vehicle ValidArticles
      this.loadFilteredArticles()

      // Load only agreementNo into list
      this.form.searchCriteria = this.form.agreementNo
      res = await Archive.loadAgreement({ facilityNo: this.form.facilityNo, no: this.form.agreementNo, searchCriteria: null, top: this.form.top, agreementNoFilter: this.agreementNoFilter, DataCode: 'quick' })
      if (!res.failed) {
        this.form.agreements = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
      }

      this.updateDeliveries()

      // Force validation of all fields to show requrired
      if (this.$refs.form && !this.$refs.form.validate()) this.valid = false

      this.$forceUpdate()
    },
    async reloadCustomers () {
      this.form.searchCriteria = this.form.customerNo
      const res = await Archive.loadCustomer({ facilityNo: this.form.facilityNo, customerNo: this.form.searchCriteria })
      if (!res.failed) {
        const item = res.data
        if (item) {
          this.form.customers = [{
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }]
        }
      }
    },
    async updateDeliveries () {
      const res = await Archive.loadDeliveries({ facilityNo: this.form.facilityNo, agreementId: this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Id') })
      if (!res.failed) {
        this.form.deliveries = res.data.map(item => {
          return {
            text: [item.No, item.Name].filter(Boolean).join(' - '),
            value: item.No,
            obj: item
          }
        })
        // Clear old value if not in new deliveries
        if (!this.form.deliveries.find(d => d.value === this.form.deliveryNo)) this.form.deliveryNo = ''
      }
    },
    async facilityChanged () {
      if (this.useFacilityDescription) {
        var facilityDisplay = this.form.facilitiesDisplay.find(f => f.value === this.form.facilityDisplay)
        if (facilityDisplay != null) {
          this.form.facilityNo = facilityDisplay.item.No
        }
      } else {
        this.form.facilityNo = this.facilityDisplay
      }

      this.preventLeave = false
      if (this.form.facilityNo != null) LocalStorage.save('facilityNo', this.form.facilityNo)
      this.form.vehicleNo = ''
      this.form.requisitionNo1 = ''
      this.form.requisitionNo2 = ''
      this.form.plantNo = ''
      this.form.carrierNo = ''
      this.form.articleNo = ''
      this.form.customerNo = ''
      this.form.agreementNo = ''
      this.form.deliveryNo = ''

      this.updateUi()
    },
    async deliveryChanged () {
      this.preventLeave = false
      var requisitionNo1 = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelRequisitionNo')
      var requisitionNo2 = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelRequisitionNo2')
      var plantNo = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelPlantNo')
      var carrierNo = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelCarrierNo')
      var articleNo = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelArticleNo')
      var customerNo = this.getValueFromArray(this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Details'), 'DelCustomerNo')

      if (requisitionNo1) this.form.requisitionNo1 = requisitionNo1
      if (requisitionNo2) this.form.requisitionNo2 = requisitionNo2
      if (plantNo) this.form.plantNo = plantNo
      if (carrierNo) this.form.carrierNo = carrierNo
      if (articleNo) { this.form.articleNo = articleNo; this.articleChanged() }
      if (customerNo) { this.form.customerNo = customerNo; this.reloadCustomers() }

      this.$forceUpdate()
    },
    async agreementChanged () {
      this.preventLeave = false
      this.form.deliveries = [this.$t('Loading ...')]
      this.form.deliveryNo = ''
      var requisitionNo1 = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'RequisitionNo')
      var requisitionNo2 = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'RequisitionNo2')
      var plantNo = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'PlantNo')
      var carrierNo = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'CarrierNo')
      var articleNo = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'ArticleNo')
      var customerNo = this.getValueFromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'CustomerNo')

      this.articleNoFilter = this.getData1FromArray(this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Details'), 'ValidArticles')

      if (requisitionNo1) this.form.requisitionNo1 = requisitionNo1
      if (requisitionNo2) this.form.requisitionNo2 = requisitionNo2
      if (plantNo) this.form.plantNo = plantNo
      if (carrierNo) this.form.carrierNo = carrierNo
      if (articleNo) { this.form.articleNo = articleNo; this.articleChanged() }
      if (customerNo) { this.form.customerNo = customerNo; this.reloadCustomers() }

      this.updateDeliveries()
      this.loadFilteredArticles()
      this.$forceUpdate()
    },
    async vehicleChanged () {
      // Fix selecting "Search" by accident
      if ((!this.form.vehicleNo && this.form.vehicles.length !== 1) || (this.form.vehicleNo && this.form.vehicleNo.includes(this.$t('Search')))) {
        this.form.vehicles = []
        this.form.vehicleNo = ''
        this.searchVehicle = ''
      }

      this.preventLeave = false
      this.form.requisitionNo1 = ''
      this.form.requisitionNo2 = ''
      this.form.plantNo = ''
      this.form.carrierNo = ''
      this.form.articleNo = ''
      this.form.customerNo = ''
      this.form.agreementNo = ''
      this.form.deliveryNo = ''

      var requisitionNo1 = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'RequisitionNo')
      var requisitionNo2 = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'RequisitionNo2')
      var plantNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'PlantNo')
      var carrierNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'CarrierNo')
      var articleNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ArticleNo')
      var customerNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'CustomerNo')
      var deliveryNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'DeliveryNo')
      var agreementNo = this.getValueFromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'AgreementNo')

      this.articleNoFilter = this.getData1FromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ValidArticles')
      this.agreementNoFilter = this.getData1FromArray(this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Details'), 'ValidAgreements')

      if (requisitionNo1) this.form.requisitionNo1 = requisitionNo1
      if (requisitionNo2) this.form.requisitionNo2 = requisitionNo2
      if (plantNo) this.form.plantNo = plantNo
      if (carrierNo) this.form.carrierNo = carrierNo
      if (articleNo) { this.form.articleNo = articleNo; this.articleChanged() }
      if (customerNo) { this.form.customerNo = customerNo; this.reloadCustomers() }
      if (agreementNo) { this.form.agreementNo = agreementNo; this.agreementChanged() }
      if (deliveryNo) { this.form.deliveryNo = deliveryNo; this.deliveryChanged() }

      this.loadFilteredArticles()
      this.loadAgreement(this.form.agreementNo)

      this.$forceUpdate()
    },
    async articleChanged () {
      this.preventLeave = false
      var plantNo = this.getValueFromArray(this.getItemFromArray(this.form.articles, this.form.articleNo, 'Details'), 'PlantNo')
      if (plantNo) this.form.plantNo = plantNo
      this.$forceUpdate()
    },
    getItemFromArray (array, findNo, findPropertyName) {
      var result = null
      if (Array.isArray(array) && array.length) {
        // array exists and is not empty
        var found = array.find(o => o.obj?.No === findNo)
        if (found) {
          // item exists
          result = found.obj[findPropertyName]
          // if property does not exist we return null
          if (result === undefined) result = null
        }
      }
      return result
    },
    getValueFromArray (array, findName) {
      var result = null
      if (Array.isArray(array) && array.length) {
        // array exists and is not empty
        var found = array.find(o => o.Name === findName)
        if (found) {
          // item exists
          result = found.Value
          // if property does not exist we return null
          if (result === undefined) result = null
        }
      }
      return result
    },
    getData1FromArray (array, findName) {
      var result = null
      if (Array.isArray(array) && array.length) {
        // array exists and is not empty
        var found = array.find(o => o.Name === findName)
        if (found) {
          // item exists
          result = found.Data1
          // if property does not exist we return null
          if (result === undefined) result = null
        }
      }
      return result
    },
    isHide (fieldName) {
      return this.hiddenFields.some(h => h === fieldName)
    },
    isReadonly (fieldName) {
      return this.readonlyFields.some(h => h === fieldName)
    },
    isRequired (fieldName) {
      return this.requiredFields.some(h => h === fieldName)
    },
    formToObject () {
      this.wlReg.facilityNo = this.form.facilityNo

      if (!this.wlReg.Registration) this.wlReg.Registration = {}

      this.wlReg.Registration.VehicleNo = this.form.vehicleNo
      this.wlReg.Registration.VehicleName = this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'Name')
      this.wlReg.Registration.VehicleLicensePlateNo = this.getItemFromArray(this.form.vehicles, this.form.vehicleNo, 'LicensePlateNo')
      this.wlReg.Registration.AgreementNo = this.form.agreementNo
      this.wlReg.Registration.AgreementName = this.getItemFromArray(this.form.agreements, this.form.agreementNo, 'Name')
      this.wlReg.Registration.DeliveryNo = this.form.deliveryNo
      this.wlReg.Registration.DeliveryName = this.getItemFromArray(this.form.deliveries, this.form.deliveryNo, 'Name')
      this.wlReg.Registration.CustomerNo = this.form.customerNo
      this.wlReg.Registration.CustomerName = this.getItemFromArray(this.form.customers, this.form.customerNo, 'Name')
      this.wlReg.Registration.ArticleNo = this.form.articleNo
      this.wlReg.Registration.ArticleName = this.getItemFromArray(this.form.articles, this.form.articleNo, 'Name')
      this.wlReg.Registration.PlantNo = this.form.plantNo
      this.wlReg.Registration.PlantName = this.getItemFromArray(this.form.plants, this.form.plantNo, 'Name')
      this.wlReg.Registration.CarrierNo = this.form.carrierNo
      this.wlReg.Registration.CarrierName = this.getItemFromArray(this.form.carriers, this.form.carrierNo, 'Name')
      this.wlReg.Registration.RequisitionNo1 = this.form.requisitionNo1
      this.wlReg.Registration.RequisitionNo2 = this.form.requisitionNo2
      this.wlReg.Registration.Comment1 = this.form.comment1
    },
    async save () {
      // Pending Vehicle check to avoid Import/Export problems and because ScanX only supports ONE Vehicle pr. 1. weighing.
      if (this.$route.params.pendingVehicles !== undefined && this.$route.params.pendingVehicles.length && this.$route.params.pendingVehicles.some(p => p === this.form.vehicleNo)) {
        this.$root.$message.showError(this.$t('Vehicle') + ' ' + this.form.vehicleNo + ' ' + this.$t('has an unfinished registration. Please Finish or use another.'))
      } else {
        this.preventLeave = false
        if (this.$refs.form.validate()) {
          this.saving = true
          this.formToObject()
          const res = await WheelLoader.saveRegistration({
            Id: this.wlReg.id,
            RegistrationId: this.wlReg.registrationId,
            Facility: this.wlReg.facilityNo,
            FinishedDate: this.wlReg.finishedDate,
            FinishedBy: this.wlReg.finishedBy,
            Comment: this.wlReg.comment,
            Registration: this.wlReg.Registration
          })
          this.saving = false
          if (!res.failed) {
            this.$root.$message.showSuccess(this.$t('Saved'))
            this.preventLeave = false
            this.$router.push({ name: this.redirectTo })
          }
        }
      }
    }
  },
  async mounted () {
    const noValue = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === undefined ?? false
    if (noValue) {
      this.useFacilityDescription = false
    } else {
      this.useFacilityDescription = Security.user.corporationDetails.find(d => d.Name === 'Sys_UseFacilityDescription')?.Data1 === 'true' ?? false
    }
    if (this.$route.params.pendingVehicles === undefined) {
      // Go back to Registrations
      this.$router.push({ name: this.redirectTo })
    }

    console.log('test')

    // We use next tick to ensure that app is initialized
    this.$nextTick(() => {
      app.$on('force-update', () => {
        // We need this to ensure that autoLogin re-renders component
        this.$forceUpdate()
      })
    })

    // Use Settings from cached user's corporatationDetails
    if (Security.user.corporationDetails) {
      const defaultHidden = 'RequisitionNo2,Plant,Carrier,Comment' // New fields default hidden LSV/MITH. Remember to also add new defaults in Settings.vue and Registrations.vue
      this.hiddenFields = (Security.user.corporationDetails.find(d => d.Name === 'WheelLoader_Fields_Hidden')?.Data1 ?? defaultHidden).split(',')
      this.readonlyFields = (Security.user.corporationDetails.find(d => d.Name === 'WheelLoader_Fields_ReadOnly')?.Data1 ?? '').split(',')
      this.requiredFields = (Security.user.corporationDetails.find(d => d.Name === 'WheelLoader_Fields_Mandatory')?.Data1 ?? '').split(',')
      this.disableCreateVehicle = Security.user.corporationDetails.find(d => d.Name === 'WheelLoader_Disable_CreateVehicle')?.Data1 === 'true' ?? false
    }

    if (this.$route.params.id) {
      this.readonlyFacility = true
      this.id = this.$route.params.id // for Create/Edit support in TitleText
      this.wlReg.id = this.$route.params.id
      const res = await WheelLoader.loadRegistration(this.wlReg.id)
      if (!res.failed) {
        this.form.facilityNo = '' + res.data.Facility

        this.updateUi()

        this.form.vehicleNo = res.data.Registration.VehicleNo
        // Load only this vehicle into form.vehicles so LicensPlate is visible and dropdown works
        if (this.form.vehicleNo) { this.loadVehicle(this.form.vehicleNo) } else this.form.vehicles = [this.$t('Search')]

        this.form.vehicleName = res.data.Registration.VehicleName
        this.form.vehicleLicensePlateNo = res.data.Registration.VehicleLicensePlateNo
        this.form.agreementNo = res.data.Registration.AgreementNo
        this.form.deliveryNo = res.data.Registration.DeliveryNo
        this.form.customerNo = res.data.Registration.CustomerNo
        this.form.articleNo = res.data.Registration.ArticleNo
        this.form.plantNo = res.data.Registration.PlantNo
        this.form.carrierNo = res.data.Registration.CarrierNo
        this.form.requisitionNo1 = res.data.Registration.RequisitionNo1
        this.form.requisitionNo2 = res.data.Registration.RequisitionNo2
        this.form.comment1 = res.data.Registration.Comment1

        this.wlReg.registrationId = res.data.RegistrationId
        this.wlReg.facilityNo = res.data.Facility
        this.wlReg.finishedDate = res.data.FinishedDate
        this.wlReg.finishedBy = res.data.FinishedBy
        this.wlReg.comment = res.data.Comment
        this.wlReg.Registration = res.data.Registration
      }
    } else {
      this.readonlyFacility = this.isReadonly('Facility') // can be setup ReadOnly
      const storedFacilityNo = '' + LocalStorage.load('facilityNo')
      if (storedFacilityNo) {
        this.form.facilityNo = '' + LocalStorage.load('facilityNo')
      }
      this.updateUi()
    }
    /* if (this.useFacilityDescription) {
      this.facilityDisplay = this.facilitiesDescription.find(f => f.item.No === this.facilityNo).value
    } */

    this.$nextTick(() => {
      this.loading = false
    })
  }
}
</script>

<style>
.licensplate-input input {
  text-transform: uppercase
}
</style>
